"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancerRequestSchema = exports.LlmCallRequestSchema = exports.ChatRequestSchema = void 0;
const zod_1 = require("zod");
exports.ChatRequestSchema = zod_1.z.object({
    messages: zod_1.z.array(zod_1.z.any()),
    chatId: zod_1.z.string().optional(),
    urlId: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    projectId: zod_1.z.uuid().optional(),
    files: zod_1.z.any().optional(),
    chatMode: zod_1.z.enum(['discuss', 'build']),
    projectType: zod_1.z.literal('landing').optional(),
    designScheme: zod_1.z.any().optional(),
});
exports.LlmCallRequestSchema = zod_1.z.object({
    system: zod_1.z.string(),
    message: zod_1.z.string(),
    model: zod_1.z.string().min(1),
    provider: zod_1.z.looseObject({ name: zod_1.z.string().min(1) }),
    streamOutput: zod_1.z.boolean().optional(),
});
exports.EnhancerRequestSchema = zod_1.z.object({
    message: zod_1.z.string().min(1),
    model: zod_1.z.string().min(1),
    provider: zod_1.z.looseObject({ name: zod_1.z.string().min(1) }),
});
